export default {
  cookies: {
    session: '1h',
    remember: '1m',
  },
  avatarSize: '100000',
};
